<div class="tools-container" [formGroup]="toolsFormGroup">
  <h4 class="tools-title">{{ 'PRESENTER.QR_CODE_TOOLS.TITLE' | translate }}</h4>

  <mat-form-field>
    <mat-label>{{ 'PRESENTER.QR_CODE_TOOLS.URL' | translate }}</mat-label>
    <input matInput [formControl]="urlControl" placeholder="https://example.com" />
  </mat-form-field>

  <mat-checkbox [formControl]="hideUrlControl">
    {{ 'PRESENTER.QR_CODE_TOOLS.HIDE_URL' | translate }}
  </mat-checkbox>

  <h5 class="tools-section-title">{{ 'PRESENTER.QR_CODE_TOOLS.STYLING' | translate }}</h5>

  <gb-token-color-picker
    circleDiameter="38px"
    [control]="backgroundColorControl"
    labelTranslateKey="PRESENTER.QR_CODE_TOOLS.BACKGROUND_COLOR"
    cpPosition="right"
    [showDropdown]="true"
  ></gb-token-color-picker>

  <gb-presenter-tools-text [toolsFormGroup]="toolsFormGroup" [hideFields]="hideFields"></gb-presenter-tools-text>
</div>
